export default __webpack_public_path__ + "static/media/VN.ec7fb22d.ico";